// A Checkout subscription uses one recurring cadence. Never convert quarterly prices to monthly prices.
export function comboGroups<T extends {monthlyAmount?:number;recurringMonths?:number}>(items:T[]):Array<{months:number;items:T[]}>{
 const periods=[...new Set(items.filter(i=>i.monthlyAmount!==undefined).map(i=>i.recurringMonths??1))];
 if(periods.length<=1)return items.length?[{months:periods[0]??0,items}]:[];
 const groups=new Map<number,T[]>();
 for(const item of items){const months=item.monthlyAmount===undefined?0:item.recurringMonths??1;groups.set(months,[...(groups.get(months)??[]),item]);}
 return [...groups].map(([months,items])=>({months,items}));
}
